import React from 'react'

export const About = () => {
    return (
        <div>
            <h1>About Screen</h1>
        </div>
    )
}
